// IMPORTANT: TAKEN STRAIGHT FROM WEB REPO.
// LOOK INTO SHARING UTIL/COMPONENT VIA NPM.

import { forEach, without } from 'lodash';

const DEFAULT_EXTRACTOR = obj => ({ short: obj.short_name, long: obj.long_name });
const NAME_EXTRACTOR = obj => obj.long_name;


// A mapping of address components we wish to extract and the fields to lookup
// from google's address components
// fields are ordered by preference
const ADDRESS_COMPONENTS = [
  {
    name: 'locality',
    fields: ['postal_town', 'sublocality_level_1', 'locality'],
  },
  {
    name: 'region',
    fields: ['sublocality_level_1', 'locality', 'administrative_area_level_1'],
  },
  {
    name: 'country',
    fields: ['country'],
  },
  {
    name: 'postcode',
    fields: ['postal_code'],
    extractor: NAME_EXTRACTOR,
  },
];

// Does the grunt work of parsing a google place into BeCollective's NamedLocationType
export default class LocationParser {
  constructor(googlePlace) {
    this.place = Object.assign({}, googlePlace);
    this.data = {
      address: null,
      locality: null,
      region: null,
      country: null,
      postcode: null,
      geo: {
        lat: null, lng: null,
      },
    };
  }

  get location() {
    return this.data;
  }

  // Extract an address component using supplied fields as a lookup
  findAndSetAddressComponent = (componentDefinition) => {
    const { name, fields, extractor = DEFAULT_EXTRACTOR } = componentDefinition;
    const components = fields.map((field) => {
      let matchedComponent;

      for (let i = 0; i < this.place.address_components.length; i++) {
        const component = this.place.address_components[i];
        if (component.types.includes(field)) {
          // Do not let an address component be reused for other subsequent extraction
          this.place.address_components.splice(i, 1);
          matchedComponent = component;
          break;
        }
      }

      return matchedComponent;
    });

    const matchedComponents = without(components, undefined);
    const firstMatched = matchedComponents[0] || {};

    this.data[name] = extractor(firstMatched);
  }

  parse() {
    let location = null;
    if (this.place.address_components) {
      ADDRESS_COMPONENTS.forEach(this.findAndSetAddressComponent);

      this.data.geo = {
        lat: this.place.geometry.location.lat(),
        lng: this.place.geometry.location.lng(),
      };

      this.data.address = this.place.formatted_address;

      forEach(this.data, (value) => {
        // Set empty string if there are no values for this address component
        if (value && (typeof value === 'object') && Object.hasOwnProperty.call(value, 'short')) {
          if (!value.short) value.short = '';
          if (!value.long) value.long = '';
        }
      });

      location = this.location; // eslint-disable-line prefer-destructuring
    }

    return location;
  }
}
